// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__2_Wtz","paramInput":"JobSimulator_paramInput__1oSP_","input":"JobSimulator_input__3RT72"};